import type {SVGAttributes} from 'react'
import {colors} from '@mui/material'

export function Welcome() {
  return <StdyLogo style={{maxHeight: '40vh', width: 'auto', zIndex: 1}}/>
}

export function StdyLogo(props: SVGAttributes<SVGSVGElement>) {
  const logoColor = colors.lightBlue['300']
  const textColor = colors.indigo['900']
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="-20 -40 430 600" {...props}>
    <path fill="none" stroke={logoColor} strokeLinecap="round" strokeLinejoin="round" strokeWidth="20" d="M366 103v70"/>
    <path fill={logoColor} d="M342 212v-25c0-14 10-24 24-24s24 10 24 24v25z"/>
    <g fill="none" stroke={logoColor} strokeLinecap="round" strokeLinejoin="round" strokeWidth="28">
      <path d="M24 60 193 2l166 56s16 7 16 18c1 11-17 19-17 19l-143 50"/>
      <path d="M87 131v56c0 41 35 97 102 99 62 2 107-55 107-96l1-64"/>
    </g>
    <path fill={textColor}
      d="M80 492q-10 0-19-3t-16-9q-6-6-9-13-2-3-1-5l5-3h5l3 4q3 5 7 8 5 4 11 6l14 2q8 0 15-3 6-3 10-8t4-12q0-10-7-16-7-7-22-9-19-2-30-12-11-9-11-23 0-10 5-17 6-8 15-12 10-4 22-4 9 0 16 3t12 8q6 4 9 10l2 6-3 4h-6l-4-3q-2-4-6-7-3-4-8-6-6-2-13-2-12 0-20 5t-8 16q0 5 3 9 3 5 10 8 6 3 18 5 20 2 30 12 9 9 9 25 0 8-3 15t-9 11q-6 5-14 7-7 3-16 3zm90-2q-8 0-15-4-6-4-10-11t-4-16v-78q0-3 2-4 2-2 5-2t5 2q2 1 2 4v78q0 8 4 13t11 5h5l4 1q2 2 2 5t-2 5q-2 2-6 2zm-38-73-5-1-1-4 1-5 5-1h39l5 1q2 2 2 5l-2 4-5 1zm99 74q-13 0-23-6t-16-16q-6-10-6-23 0-12 6-23 6-10 15-15 10-6 22-6 10 0 19 4 8 4 13 12v-46q0-3 2-5t5-2q3 0 5 2t2 5v75q0 12-6 22t-16 16q-10 6-22 6zm0-12q9 0 16-5 7-4 11-11 4-8 4-17t-4-16q-4-8-11-12t-16-4q-9 0-16 4t-11 12q-4 7-4 16t4 17q4 7 11 11 7 5 16 5zm78 49-3-1q-6-2-3-8l51-113q2-5 8-3 6 3 3 8l-51 113q-1 4-5 4zm18-41h-4q-3 0-4-3l-36-73v-5q0-2 3-3h5q2 0 4 3l35 73v5q0 2-3 3z"
    />
  </svg>
}
